import { render, staticRenderFns } from "./juShiJiLei.vue?vue&type=template&id=71592316&scoped=true&"
import script from "./juShiJiLei.vue?vue&type=script&lang=js&"
export * from "./juShiJiLei.vue?vue&type=script&lang=js&"
import style0 from "./juShiJiLei.vue?vue&type=style&index=0&id=71592316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71592316",
  null
  
)

export default component.exports